import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { filterDataforApi, pageNo, rowCount } from 'utils/redux/reducer/filter-slice';
import strings from '../../../../common/Translation/Translate';
import axiosInstance from '../../../../utils/axios';
import { privileges } from '../../../../utils/constants/privileges';
import { routes } from '../../../../utils/constants/routes';
import { URLS } from '../../../../utils/constants/urls';
import ListPage from '../../CommonPage';
import { usageTableColumn } from '../../CommonPage/usageColumn';

const ParentOrganizationList: FC = () => {
  const index = useSelector(pageNo);
  const filter = useSelector(filterDataforApi);
  const pageSize = useSelector(rowCount);
  const [pageResponse, setPageResponse] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const pageConfig = useMemo(
    () => ({
      title: strings.parentOrg_title_list,
      subtitle: strings.parentOrg_list_subtitle,
      entityLabel: 'Parent Organizations',
      AddButtonText: strings.parentOrg_column_add,
      AddButtonUrl: routes.addParentOrganization,
      editButtonUrl: routes.editParentOrganization,
      listApi: URLS.parentOrganization,
      deleteApi: URLS.edit_taxCode,
      addPrivilege: null,
      editPrivilege: privileges.edit_parent_organization,
      tableColumn: [
        {
          field: 'logoUrl',
          headerName: '',
          flex: 1,
          image: true,
          imageInitialsField: 'name',
        },
        {
          field: 'name',
          headerName: strings.parentOrg_column_name,
          flex: 2,
          sortable: true,
          localField: 'localizedAttributes.name',
        },
        usageTableColumn(
          row => [
            { count: row.segmentCount, singular: 'Segment', plural: 'Segments' },
            { count: row.venueCount, singular: 'Venue', plural: 'Venues' },
            { count: row.locationCount, singular: 'Location', plural: 'Locations' },
          ],
          '',
        ),
      ],
    }),
    [],
  );

  const getList = useCallback(
    async (filterData: any) => {
      try {
        setLoading(true);
        const body = filterData
          ? filterData
          : { page: index + 1, size: pageSize, filter: filter, sort: ['createdAt:desc'] };
        const { data } = await axiosInstance.post(pageConfig.listApi, body);
        setLoading(false);
        setPageResponse(data);
      } catch (error: any) {
        setLoading(false);
      }
    },
    [pageConfig.listApi, index, pageSize, filter],
  );

  useEffect(() => {
    (async () => {
      await getList(null);
    })();
  }, [getList]);

  return <ListPage isLoading={loading} pageConfig={pageConfig} pageResponse={pageResponse} getList={getList} />;
};

export default ParentOrganizationList;
